import { CutNftNumber } from '@/lib/Shorten';
import { OwnedNft } from 'alchemy-sdk';

type CombineNameType = {
  [key: string]: OwnedNft[];
};
export const combineName = (aData: OwnedNft[]) => {
  // const groupedArray1: OwnedNft[] = aData.reduce((acc, obj) => {
  //   acc.findIndex(({ address }) => address === obj.contract.address) === -1;
  //   return '1';
  // });
  const groupedArray: OwnedNft[] = aData.reduce((acc, obj) => {
    if (acc.findIndex(({ contract }) => contract.address === obj.contract.address) === -1) {
      console.log();
      const payload = {
        ...obj,
        name: obj.contract.name,
      };
      acc.push(payload);
    }
    return acc;
  }, [] as OwnedNft[]);

  return groupedArray;
};
